import saMessages from '@app/i18n/locales/ar_SA.json';
import antdSA from 'antd/lib/locale-provider/en_US';
// import appLocaleData from 'react-intl/locale-data/ar';

const saLang = {
  messages: {
    ...saMessages,
  },
  antd: antdSA,
  locale: 'ar',
  // data: appLocaleData,
};
export default saLang;
